// Subscription classification is separate from permission to use admin tools.
export function isSubscriptionApplicable(user) {
    return String(user?.role || '').trim().toLowerCase() !== 'admin';
}
